import React from "react";
import { Helmet } from 'react-helmet-async';
import "../../../assets/styles/InfluencerMarketing.css";
import influencerHero from "../../../assets/images/influencer.jpg";
import influencerCollab from "../../../assets/images/influencer.jpg";

const InfluencerMarketingPage = () => {
  return (
    <div className="influencer-container">
      <Helmet>
        <title>Influencer Marketing – BuddyTech Solutions</title>
        <meta name="description" content="Grow your brand's reach and trust through influencer marketing campaigns that connect with authentic audiences." />
        <meta name="keywords" content="influencer marketing, brand promotion, social influencers, Instagram collab, influencer campaigns, digital PR" />

        <meta property="og:title" content="Influencer Marketing – BuddyTech Solutions" />
        <meta property="og:description" content="Grow your brand's reach and trust through influencer marketing campaigns that connect with authentic audiences." />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/marketing/influencer" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Influencer Marketing – BuddyTech Solutions" />
        <meta name="twitter:description" content="Grow your brand's reach and trust through influencer marketing campaigns that connect with authentic audiences." />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>

      <header className="influencer-hero">
        <div className="influencer-hero-content">
          <h1>Influencer Marketing</h1>
          <p>
            Collaborate with trusted voices to elevate your brand presence across social platforms through curated influencer partnerships.
          </p>
        </div>
        <img src={influencerHero} alt="Influencer Hero" className="influencer-hero-img" />
      </header>

      <section className="influencer-section">
        <div className="influencer-text">
          <h2>Our Collaboration Model</h2>
          <p>
            We help brands identify and engage the right influencers for impactful storytelling and authentic audience engagement.
          </p>
          <ul>
            <li>Influencer Sourcing & Outreach</li>
            <li>Campaign Planning & Briefing</li>
            <li>Sponsored Posts & Giveaways</li>
            <li>Micro & Macro Influencer Strategy</li>
            <li>Reporting & Engagement Analytics</li>
          </ul>
        </div>
        <img src={influencerCollab} alt="Influencer Collaboration" className="influencer-img" />
      </section>

      <section className="influencer-tools">
        <h2>Platforms & Networks</h2>
        <div className="tools-grid">
          <span>Instagram</span>
          <span>YouTube</span>
          <span>X (Twitter)</span>
          <span>Facebook</span>
          <span>LinkedIn</span>
          <span>Upfluence</span>
          <span>Heepsy</span>
          <span>Tagger</span>
        </div>
      </section>
      <section className="contact-options">
                <div className="contact-card email">
                    <h2>📧 Email</h2>
                    <p>Send us an email for inquiries, support or collaboration opportunities.</p>
                    <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
                        Send Email
                    </a>
                </div>

                <div className="contact-card whatsapp">
                    <h2>💬 WhatsApp</h2>
                    <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
                    <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
                        Chat on WhatsApp
                    </a>
                </div>

                <div className="contact-card phone">
                    <h2>📞 Call Us</h2>
                    <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
                    <a href="tel:+919842084312">Call Us</a>
                </div>
            </section>
    </div>
  );
};

export default InfluencerMarketingPage;
